export default __webpack_public_path__ + "static/media/wpengine.7903e679.svg";